<!-- Fixed glow background -->
<div class="glow-background"></div>

<!-- Content wrapper -->
<div class="relative z-10 flex flex-col min-h-screen">
  <!-- Header Section -->
  <header class="fixed top-0 left-0 right-0 z-50">
    <div class="flex items-center justify-between">
      <div class="flex items-center pl-4">
        @if(page != 'usdm') {
          <app-drawer></app-drawer>
        } @else {
          <app-usdm-drawer></app-usdm-drawer>
        }
        <!-- Logo Section -->
        <img [src]="'./assets/logo2.svg'" alt="Logo"
          class="h-12 w-30 ml-4 transform transition-all duration-300 cursor-pointer" (click)="navigateToHome()" />
      </div>

      <!-- Navigation -->
      <div class="flex items-center gap-4">
        @if(isHomePage()) {
          <a href="/docs" class="mt-3">
            <button class="group flex items-center gap-2 px-5 py-2 rounded-full bg-white/50 backdrop-blur-xl border border-white/40 shadow-[0_4px_14px_rgba(21,148,253,0.12),inset_0_1px_0_rgba(255,255,255,0.6)] cursor-pointer transition-all duration-200 ease-out hover:-translate-y-px hover:border-[#1594fd] hover:bg-white/60 hover:shadow-[0_8px_24px_rgba(21,148,253,0.22),inset_0_1px_0_rgba(255,255,255,0.7)] active:translate-y-0 active:scale-[0.98]">
              <span class="text-sm font-bold tracking-wide bg-gradient-to-br from-[#1594fd] via-[#06b6d4] to-[#0d7fe6] bg-clip-text text-transparent">Docs</span>
              <span class="pi pi-book text-xs text-[#1594fd] transition-transform duration-200 ease-out group-hover:scale-110"></span>
            </button>
          </a>
        }
        @if(hasOsbServerUrl()) {
          <div class="mt-4 cursor-pointer">
            <a [href]="getOsbServerUrl()" target="_blank">
              <img [src]="'image.png'" alt="User Icon" class="h-10 w-30" />
            </a>
          </div>
        }
        <!-- Add the new PrimeMenu component -->
        <app-prime-menu class="mt-2 mr-4"></app-prime-menu>
        <!-- <app-user></app-user> -->
      </div>
    </div>
  </header>

  <!-- Enhanced toast component with animations -->
  <p-toast position="top-right" [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'300ms'"
    [hideTransitionOptions]="'300ms'" styleClass="custom-toast"></p-toast>

  <!-- Main Content -->
  <div class="p-2 pt-18 flex-grow fixed w-full h-full">
    <router-outlet></router-outlet>
  </div>
</div>